const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

function setColorScheme(scheme) {
  const root = document.documentElement
  const prefersDark = darkModeMediaQuery.matches
  const isDark = scheme === 'dark' || (scheme === 'system' && prefersDark)

  root.classList.toggle('dark-theme', isDark)

  document.querySelectorAll('[id^="colorToggleButton"]').forEach((button) => {
    button.setAttribute('aria-pressed', isDark.toString())
    button.classList.remove('light-scheme', 'dark-scheme', 'system-light', 'system-dark')

    if (scheme === 'system') {
      button.classList.add(prefersDark ? 'system-dark' : 'system-light')
    } else {
      button.classList.add(`${scheme}-scheme`)
    }
  })

  document.cookie = `preferredColorScheme=${scheme}; path=/; SameSite=Lax`
}

function toggleColorScheme() {
  const currentScheme = document.cookie.match(/preferredColorScheme=([^;]+)/)?.[1] || 'system'
  const newScheme = currentScheme === 'system' ? (darkModeMediaQuery.matches ? 'light' : 'dark') : currentScheme === 'dark' ? 'light' : 'dark'

  setColorScheme(newScheme)
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="colorToggleButton"]').forEach((button) => {
    button.addEventListener('click', toggleColorScheme)
  })

  darkModeMediaQuery.addEventListener('change', (e) => {
    const currentScheme = document.cookie.match(/preferredColorScheme=([^;]+)/)?.[1] || 'system'
    if (currentScheme === 'system') {
      setColorScheme('system')
    }
  })

  const savedScheme = document.cookie.match(/preferredColorScheme=([^;]+)/)?.[1] || 'system'
  setColorScheme(savedScheme)
})
